import { Component, inject, OnInit } from '@angular/core';
import { Location, NgOptimizedImage } from '@angular/common';
import { FrontpageAlertData } from '@mwe/models';
import { FeatureFrontpageModule } from '@mwe/features/frontpage';
import { fullRoutePrefix, ROUTE_LOGOUT_SUCCESS } from '@shared-ikp/app.constants';
import { HeaderLogoComponent } from '@shared-ikp/layout/header/header-logo/header-logo.component';
import { IkpAuthService } from '@shared-ikp/service/auth/ikp-auth.service';
import { BeraterEnvironmentService } from '../../service/environment/berater-environment.service';

@Component({
  selector: 'ikp-berater-frontpage',
  standalone: true,
  imports: [FeatureFrontpageModule, HeaderLogoComponent, NgOptimizedImage],
  templateUrl: './frontpage.component.html',
  styleUrl: './frontpage.component.scss',
})
export class FrontpageComponent implements OnInit {
  authService = inject(IkpAuthService);
  environmentService = inject(BeraterEnvironmentService);
  location = inject(Location);
  showAuthServerAlert = false;
  authServerAlertData: FrontpageAlertData;
  isLoaded = false;

  ngOnInit(): void {
    if (window.location.hash.indexOf('logout=success') !== -1) {
      this.authServerAlertData = {
        type: 'success',
        title: 'global.home.logoutSuccess.title',
        message: 'global.home.logoutSuccess.message',
      };
      this.showAuthServerAlert = true;
      this.deleteHashFromBaseUrl();
    }
    this.isLoaded = true;
  }

  private deleteHashFromBaseUrl() {
    const newUrl = window.location.href.replace(fullRoutePrefix(ROUTE_LOGOUT_SUCCESS), '');
    this.location.replaceState(newUrl);
  }

  login() {
    this.authService.login();
  }

  register() {
    this.authService.register();
  }
}
